import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOCATION_REQUEST } from "./types";

interface LocationState {
  countries: any | null;
  states: any | null;
  loading: boolean;
  error: any | null;
}

const locationInitialState: LocationState = {
  countries: null,
  states: null,
  loading: false,
  error: null,
};

export const locationSlice = createSlice({
  name: LOCATION_REQUEST,
  initialState: locationInitialState,
  reducers: {
    getCountriesListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCountriesListSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.countries = action.payload.response;
    },
    getCountriesListFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getStatesByCountryRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getStatesByCountrySuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.states = action.payload.response;
    },
    getStatesByCountryFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    resetLocationsData(state) {
      state.states = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getCountriesListRequest,
  getCountriesListSuccess,
  getCountriesListFailure,
  getStatesByCountryRequest,
  getStatesByCountrySuccess,
  getStatesByCountryFailure,
  resetLocationsData,
} = locationSlice.actions;
export default locationSlice.reducer;
